import { FatalError } from "@prismicio/editor-support/Error"
import {
  Breadcrumbs,
  BrowserClient,
  Dedupe,
  defaultStackParser,
  getCurrentHub,
  GlobalHandlers,
  HttpContext,
  makeFetchTransport,
} from "@sentry/react"

import { env } from "../env"
import { getRepositoryName } from "../routing"

export const createSentryClient = () => {
  const client = new BrowserClient({
    environment: env.PRISMIC_PAGE_BUILDER_SENTRY_ENVIRONMENT,
    dsn: env.PRISMIC_PAGE_BUILDER_SENTRY_DSN,
    tracesSampleRate: 0.01,
    transport: makeFetchTransport,
    stackParser: defaultStackParser,
    integrations: [
      new Breadcrumbs(),
      new GlobalHandlers(),
      new Dedupe(),
      new HttpContext(),
    ],
    beforeSend(event, hint) {
      if (!shouldSendError(hint.originalException)) return null

      event.tags ||= {}
      event.tags["repository"] = getRepositoryName()
      event.tags["commit"] = env.PRISMIC_GIT_COMMIT_HASH
      return event
    },
  })

  getCurrentHub().bindClient(client)
}

function shouldSendError(error: unknown) {
  // We throw a FatalError when the error can not be recovered from by clicking "try again".
  // There's nothing to report as this represents an expected/valid Page Builder control flow interruption.
  if (error instanceof FatalError) return false

  return true
}
